<div style="position: relative">
  <ng-container *ngIf="isLoading">
    <div
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        z-index: 9;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <mat-spinner></mat-spinner>
    </div>
  </ng-container>
  <form [formGroup]="form">
    <fieldset [disabled]="isLoading" style="border: none; padding: 0; margin: 0">
      @for (row of getFieldRows(normalFields); track $index) {
        <div class="grid gap-4 grid-cols-3">
          @for (field of row; track field.name) {
            <div [ngClass]="row.length === 1 ? 'col-span-3' : ''">
              <h1 class="mb-2 text-gray-700">{{ field.label }}:</h1>
              @switch (field.type) {
                @default {
                  <app-input
                    [label]="field.altLabel ?? field.label"
                    [type]="field.type"
                    [field]="field"
                    [formControl]="getFormControl(field.name)"
                    [errorMessage]="
                      form.get(field.name)?.invalid && (form.get(field.name)?.touched || submited)
                        ? getErrorMessage(field.name)
                        : ''
                    "
                  />
                }
                @case ('select') {

                  <mat-form-field class="example-full-width">
                    <mat-label>{{ field.altLabel ?? field.label }}</mat-label>
                    <input
                      matInput
                      type="text"
                      [matAutocomplete]="autoSelect"
                      [formControl]="getFormControl(field.name)"
                      (input)="filterAutoComplete($event.target.value, field.options,field.name)"
                    />
                    <mat-autocomplete
                      #autoSelect="matAutocomplete"
                      (optionSelected)="selectValueAutoEvent($event, field.options, field.name)"
                      [displayWith]="displayLabel"
                    >
                      <mat-option
                        *ngFor="let option of (selectOptionsFiltered[field.name] ? selectOptionsFiltered[field.name] : field.options)"
                        [value]="option"
                      >
                        {{ option.label }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="form.get(field.name)?.invalid && (form.get(field.name)?.touched || submited)">
                      {{ getErrorMessage(field.name) }}
                    </mat-error>
                  </mat-form-field>
                }
                @case ('date') {
                  <app-datepicker
                    [formControl]="getFormControl(field.name)"
                    [errorMessage]="
                      form.get(field.name)?.invalid && (form.get(field.name)?.touched || submited)
                        ? getErrorMessage(field.name)
                        : ''
                    "
                    [label]="field.altLabel ?? field.label"
                  >
                  </app-datepicker>
                }
              }
            </div>
          }
        </div>
      }

      <!-- Lista de checkboxes al final -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        @for (field of checkboxFields; track field.name) {
          <div>
            <mat-checkbox [formControl]="getFormControl(field.name)">
              {{ field.altLabel ?? field.label }}
            </mat-checkbox>
          </div>
        }
      </div>
    </fieldset>
  </form>
</div>
